<script>
  import Card from '/components/Atoms/Card'
  import Link from '/components/Atoms/Link'
  import CardAlmanac from '/Widgets/CardAlmanac'
  import CardProjectEvent from '/Widgets/CardProjectEvent'
  import { _ } from 'svelte-i18n'
  import Query from '/components/Atoms/Query'
  import RelatedWidgets from '/Groups/RelatedWidgets'

  import RELATED_ENTRIES from '/gql/relatedEntries.gql'

  export let data, almanac

  const status = process.env.SHOW_PENDING ? ["live", "pending"] : ["live"]

  console.log(data)

  const ids = [
    ...data?.relatedArtworks || [],
    ...data?.relatedText || [],
    ...data?.relatedEvents || [],
    ...data?.relatedProjects || [],
    ...data?.relatedPeople || [],
    ...data?.relatedMedia || [],
    ...data?.relatedCollections || [],
  ].map(r => r.id)

  console.log("related items IDs", ids)

  let relatedArtworks = []

</script>

<Query gql={RELATED_ENTRIES} variables={{ status, id: ids }} let:data>
  <RelatedWidgets related={data.related} {almanac} />
</Query>

